import {
  BloodPresureIcon,
  CardiologyIcon,
  Sop2Icon,
  GlucoseIcon,
  ThermometerIcon
} from '../../Assets/icons';
export const provincesData = [
  { label: 'Sindh', value: 1 },
  {
    label: 'Balochistan',
    value: 2
  }
];

export const cityData = [
  { label: 'Karachi', value: '1' },
  { label: 'Lahore', value: 1 }
];

export const termsOfServicesData = [
  {
    id: 1,
    heading: '1. Introduction',
    paragraph:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem.'
  },
  {
    id: 2,
    heading: '2. Conditions of use',
    paragraph: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem.`
  },
  {
    id: 3,

    heading: '3. Your Account',
    paragraph: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem.  Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra `
  }
];

export const privacyPolicyData = [
  {
    id: 1,
    paragraph: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem.`
  },
  {
    id: 2,
    paragraph: `1.1.   Lorem ipsum dolor sit amet,   consectetur adipiscing elit. Viverra condimentum eget purus in. Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et.`
  },
  {
    id: 3,
    paragraph: `1.2.   Lorem ipsum dolor sit amet,   consectetur adipiscing elit. Viverra condimentum eget purus in. Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et.`
  },
  {
    id: 4,
    paragraph: `1.2.3.   Lorem ipsum dolor sit amet,   consectetur adipiscing elit. Viverra condimentum eget purus in. Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et. Amet quam placerat sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra condimentum eget purus in.Consectetur eget id morbi amet amet, in. Ipsum viverra pretium tellus neque. Ullamcorper suspendisse aenean leo pharetra in sit semper et.`
  }
];

export const medicineList = [
  {
    id: 1,
    cellNumber: '03220654814',
    name: 'Maria Hashim Bangash',
    age: '24/Gender',
    lastVisit: '12 jan 2024',
    upComing: '24 jan 2024',
    total: '12,40'
  },
  {
    id: 2,
    cellNumber: '03220654814',
    name: 'Maria Hashim Bangash',
    age: '24/Gender',
    lastVisit: '12 jan 2024',
    upComing: '24 jan 2024',
    total: '12,40'
  },
  {
    id: 3,
    cellNumber: '03220654814',
    name: 'Maria Hashim Bangash',
    age: '24/Gender',
    lastVisit: '12 jan 2024',
    upComing: '24 jan 2024',
    total: '12,40'
  },
  {
    id: 4,
    cellNumber: '03220654814',
    name: 'Maria Hashim Bangash',
    age: '24/Gender',
    lastVisit: '12 jan 2024',
    upComing: '24 jan 2024',
    total: '12,40'
  }
];

export const services = [
  { id: 1, service: 'Braces (1/5)' },
  { id: 2, service: 'OPD (1,000)' },
  { id: 3, service: 'OPD (1,000)' },
  { id: 4, service: 'OPD (1,000)' }
];

export const upComingAppointmentsData = [
  { id: '1', visitName: 'Visit # 06', day: 'Today', time: '12:30 pm' },
  { id: '2', visitName: 'Visit # 07', day: '21 Jun 2024', time: '12:30 pm' }
];

export const statsData = {
  cashFlow: { id: '1', title: 'Cash Flow', total: 'Rs.12,450', extra: 'Waived - Rs 400' },
  totalPatients: { id: '2', title: 'Total Patients', total: '14', extra: 'Removed - 1' },
  newPatients: { id: '3', title: 'New Patients', total: '10', extra: 'Prev. Day +9.3%' }
};

export const todayAppointmentsData = [
  { id: 1, name: 'Maria Hashim Bangash', appointmentsData: '03:00 pm - 03:30 pm' },
  { id: 2, name: 'Maria Hashim Bangash', appointmentsData: '03:00 pm - 03:30 pm' },
  { id: 3, name: 'Maria Hashim Bangash', appointmentsData: '03:00 pm - 03:30 pm' },
  { id: 4, name: 'Maria Hashim Bangash', appointmentsData: '03:00 pm - 03:30 pm' }
];

export const dashboardServices = [
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)',
  'OPD (Rs. 1,000)'
];
export const currentSessionData = [
  {
    rowNum: '1',
    tokenNumber: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '2',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  },
  {
    rowNum: '3',
    tokenNo: 'abcd',
    age: 5,
    gender: 'male',
    cellNumber: '03222098761',
    patientType: 'follow up',
    fees: '5000',
    services: [
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)',
      'OPD (Rs. 1,000)'
    ]
  }
];

export const slots = {
  'Afternoon Slots': [
    { id: '1', label: '01:00 pm' },
    {
      id: '2',
      label: '01:30 pm'
    },
    { id: '3', label: '02:00 pm' },
    { id: '4', label: '02:30 pm' },
    { id: '5', label: '03:00 pm' },
    { id: '6', label: '03:30 pm' },
    { id: '7', label: '04:00 pm' },
    { id: '8', label: '04:30 pm' }
  ],
  'Evening Slots': [
    { id: '11', label: '08:00 pm' },
    { id: '12', label: '08:00 pm' },
    { id: '13', label: '09:00 pm' }
  ],
  'Night Slots': [
    { id: '21', label: '01:00 pm' },
    {
      id: '22',
      label: '01:30 pm'
    },
    { id: '23', label: '02:00 pm' },
    { id: '24', label: '02:30 pm' },
    { id: '25', label: '03:00 pm' },
    { id: '26', label: '03:30 pm' },
    { id: '27', label: '04:00 pm' },
    { id: '28', label: '04:30 pm' }
  ]
};

export const servicesOptionList = [
  { id: '1', label: 'IV Drip (500)', fee: 200 },
  { id: '2', label: 'Fee Type (000)', fee: 300 },
  { id: '3', label: 'Fee  (000)', fee: 500 },
  { id: '4', label: 'Fee Type (800)', fee: 600 }
];

export const servicesList = [
  {
    id: 1,
    name: 'Vaccination',
    fee: 400
  },
  {
    id: 2,
    name: 'Drip',
    fee: 200
  },
  {
    id: 3,
    name: 'OPD',
    fee: 500
  },
  {
    id: 4,
    name: 'Blood Test',
    fee: 1000
  }
];

export const linkPatientList = [
  { id: '1', label: 'Maria Bangash' },
  { id: '2', label: 'Aman Khan' },
  { id: '3', label: 'Kareem Hassan' }
];

export const previousVitalsData = {
  time: '01:15 pm',
  data: [
    { id: 1, label: 'Blood Presure', value: '120/80', img: <BloodPresureIcon /> },
    { id: 2, label: 'Heart Rate', value: '80 bpm', img: <CardiologyIcon /> },
    { id: 3, label: 'Temperature', value: '101°F (38°C)', img: <ThermometerIcon /> },
    { id: 4, label: 'SPO2', value: '95%', img: <Sop2Icon /> },
    { id: 5, label: 'Sugar Level', value: '110 mg/dl', img: <GlucoseIcon /> }
  ]
};

export const drugType = [
  { id: '1', label: 'Generic1', value: 'generic1' },
  { id: '2', label: 'Generic2', value: 'generic2' }
];

export const drugAllergy = [
  { id: '1', label: 'Paracetamol', value: 'Paracetamol' },
  { id: '2', label: 'Paracetamol2', value: 'Paracetamol2' }
];

export const drugAllergyList = [
  {
    id: 1,
    name: 'Ansaid',
    fee: 'Ansaid'
  },
  {
    id: 2,
    name: 'Drip',
    fee: 200
  },
  {
    id: 3,
    name: 'Panadol',
    fee: 500
  },
  {
    id: 4,
    name: 'Augmentin',
    fee: 1000
  }
];

export const packageList = [
  {
    id: 1,
    oldPrice: '',
    title: 'Basic Package',
    description: '250 SMS per month',
    price: 'Rs. 1,000'
  },
  {
    id: 2,
    oldPrice: 'Rs. 2,000',
    title: 'Standard Package',
    description: '500 SMS per month',
    price: 'Rs. 1,799'
  },
  {
    id: 3,
    oldPrice: 'Rs. 4000',
    title: 'Premium Package',
    description: '1000 SMS per month',
    price: 'Rs. 3,449'
  }
];

export const allStatistics = [
  { id: '1', value: 250, perc: 8.5, cardName: 'Total Patients' },
  { id: '2', value: 690, perc: 8.5, cardName: 'New Patients' },
  { id: '3', value: 7500, perc: 8.5, cardName: 'Payments' },
  { id: '3', value: 120, perc: 8.5, cardName: 'Follow-up' }
];
